import moment from 'moment';

import {
    getCreateDateTime
} from '../../utils/DateUtils';

export const deposMasterModel = () => {
    return {
        docId: null,
        docNo: null,
        docDate: moment().utcOffset(7, true).format('YYYY-MM-DD HH:mm:ss.SSS'),
        docDueDate: moment().utcOffset(7, true).format('YYYY-MM-DD HH:mm:ss.SSS'),
        docStatus: 1,
        docCode: null,
        docType: 1,
        docFor: 1,
        refDocID: null,
        refDoc: null,
        refDocDate: null,
        refProjectID: null,
        refProjectNo: null,
        compId: null,
        transportType: 1,
        docRemark1: null,
        docRemark2: null,
        arID: null,
        arCode: null,
        actionHold: null,
        discountValue: 0,
        discountValueType: null,
        discountValueTotal: 0,
        discountCash: null,
        discountCashType: null,
        discountTransport: null,
        discountTransportType: null,
        isVat: null,
        docSEQ: null,
        creditTerm: 0,
        creditTerm1Day: 0,
        creditTerm1Remark: null,
        creditTerm2Remark: null,
        accCode: null,
        empName: null,
        createdDate: getCreateDateTime(),
        createdByName: window.localStorage.getItem('name'),
        createdById: window.localStorage.getItem('emp_id'),
        updateDate: null,
        updateByName: null,
        updateById: null,
        cancelDate: null,
        cancelByName: null,
        cancelById: null,
        printedStatus: null,
        printedDate: null,
        printedBy: null,
        confirmById: null,
        confirmDate: null,
        confirmByName: null,
        payType: null,
        approvedPayDate: null,
        approvedPayByName: null,
        approvedPayById: null,
        custName: null,
        custTel: null,
        custMail: null,
        custConfirmMemo: null
    };
};